import { parseEnv } from '@/helpers/route-utils';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/$env/experiments/new')({
  params: parseEnv(),
});
